module.exports = __webpack_public_path__ + "img/pr-6.ab80b2ad.png";